export const iconFontAwesomeArrowsSquareCaretDown = (
	<i className="fa-solid fa-square-caret-down"></i>
);
